import axios from 'axios';
import { getGlobalShowError } from '../components/utils/errorModalSingleton';

const backendApi = axios.create({
    baseURL: process.env.REACT_APP_BACKEND_API_BASE_URL,
    withCredentials: true,
});

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, tokenRefreshed = false) => {
    failedQueue.forEach(({ resolve, reject }) => {
        if (tokenRefreshed) {
            resolve();
        } else {
            reject(error);
        }
    });
    failedQueue = [];
};

backendApi.interceptors.response.use(
    response => response,
    async error => {
        const originalRequest = error.config;

        if (
            error.response &&
            error.response.status === 401 &&
            !originalRequest._retry &&
            !originalRequest.url.includes('/api/refresh')
        ) {
            originalRequest._retry = true;

            if (isRefreshing) {
                return new Promise((resolve, reject) => {
                    failedQueue.push({ resolve, reject });
                }).then(() => backendApi(originalRequest));
            }

            isRefreshing = true;

            try {
                await backendApi.post('/api/refresh');
                processQueue(null, true);
                return backendApi(originalRequest);
            } catch (refreshError) {
                processQueue(refreshError, false);

                setTimeout(() => {
                    localStorage.removeItem('user');
                    window.location.href = '/login';
                }, 0);

                return new Promise(() => {});
            } finally {
                isRefreshing = false;
            }
        }

        if (error.response && error.response.status === 403) {
            const showError = getGlobalShowError();

            if (showError) {
                showError('Jūs esate užblokuotas. Susisiekite su administracija el. paštu klausk@1424.lt');
            }

            return Promise.reject(error);
        }

        return Promise.reject(error);
    }
);

export default backendApi;
